import { useEffect, useState } from "react";

export interface AppVersionInfo {
  version: string;
  name: string;
  isLoading: boolean;
}

export function useAppVersion(): AppVersionInfo {
  const [versionInfo, setVersionInfo] = useState<AppVersionInfo>({
    version: "unknown",
    name: "App",
    isLoading: true,
  });

  useEffect(() => {
    const getVersion = async () => {
      try {
        const envVersion = process.env.REACT_APP_VERSION;

        if (envVersion) {
          setVersionInfo({
            version: envVersion,
            name: "App",
            isLoading: false,
          });
          return;
        }

        try {
          const response = await fetch("/version.json");
          if (response.ok) {
            const versionData = await response.json();
            setVersionInfo({
              version: versionData.version || "1.1.0",
              name: versionData.name || "App",
              isLoading: false,
            });
            return;
          }
        } catch (e) {
          // Continue to next fallback
        }

        setVersionInfo({
          version: "1.1.0",
          name: "asset-rental",
          isLoading: false,
        });
      } catch (error) {
        setVersionInfo({
          version: "0.1.0",
          name: "asset-rental",
          isLoading: false,
        });
      }
    };

    getVersion();
  }, []);

  return versionInfo;
}
